module.exports = __webpack_public_path__ + "static/media/laravel-logo.32442a8e.svg";